<template>
  <ReportBaseSelectFilter
    class="payment-type-filter"
    label="Payment Types"
    placeholder="All payment types"
    :options="allTeamPaymentSourceNamesForSelect"
    query-property="payment_sources"
  />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReportPaymentTypeFilter',
  computed: {
    ...mapGetters(['allTeamPaymentSourceNamesForSelect']),
  },
};
</script>
